import { render, staticRenderFns } from "./AddFamilyComponent.vue?vue&type=template&id=0211c0b6&"
import script from "./AddFamilyComponent.vue?vue&type=script&lang=js&"
export * from "./AddFamilyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports